// extracted by mini-css-extract-plugin
export default {"melodyVideo":"sO-z","isFullWidth":"tO-z","landingPageVideo":"uO-z","play":"vO-z","iframeVideo":"wO-z","playHidden":"xO-z","fullwidth":"yO-z"};